/** Lazy-loads the domAnimation feature set — no layout/drag support. */
export const loadFeatures = () =>
  import("motion/react").then((mod) => mod.domAnimation);

// domMax lives in its own module so this file stays free of static
// motion/react imports and `ease` importers don't pull it into their chunk.
/** Lazy-loads the full domMax feature set, incl. layout animations. */
export const loadMotionFeatures = () =>
  import("@/components/motion/features").then((mod) => mod.domMax);

const elegant = {
  type: "spring",
  stiffness: 150,
  damping: 19,
  mass: 1.2,
} as const;

export const ease = {
  spring: {
    elegant,
    slow: {
      stiffness: 26.7,
      damping: 4.1,
      mass: 0.2,
    },
  },
  cubic: {
    swiftOut: { ease: [0.175, 0.885, 0.32, 1.1] },
    out: { ease: [0.23, 1, 0.32, 1] },
    inOut: {
      ease: [0.42, 0, 0.58, 1],
    },
    inOutCubic: {
      ease: [0.645, 0.045, 0.355, 1],
    },
  },
} as const;
